import React, { FC, useRef } from 'react';
import { MapView } from '../../esri/types';
import { useIntegratedEsriMapStore } from '../hooks/use-integrated-esri-map-store';
import { MapGlobalContext } from '../context/map-global-context';
import { useBroadcast } from '~/common/broadcast-channel/use-broadcast';

export const MapGlobalProvider: FC = ({ children }): React.ReactElement => {
    const esriMapStore = useIntegratedEsriMapStore();
    const esriMapViewRef = useRef<MapView>();

    useBroadcast('preferences-notifications', (message) => {
        if (message.type === 'THEME_CHANGED') {
            esriMapStore.setMapMode(message.payload.theme === 'dark' ? 'DARK_MODE' : 'LIGHT_MODE');
        }
    });

    return (
        <MapGlobalContext.Provider value={{ esriMapStore, esriMapViewRef }}>
            {children}
        </MapGlobalContext.Provider>
    );
};
